export default __webpack_public_path__ + "alberta-vendor.56843f0a996f6676e423.svg";